import { PencilIcon } from '../../../../assets/icons/PencilIcon';
import { EditIcon } from '../../../../assets/icons/EditIcon';
import { StarIcon } from '../../../../assets/icons/StarIcon';

const HowToScoreCard = () => {
  return (
    <div className='w-[263px] p-6'>
      {/* Content */}
      <div className='relative flex flex-col items-center justify-center gap-3 rounded-lg border-hairline border-card-color-default bg-mono-color-lightest pb-5 pt-8 text-base shadow-level-1'>
        {/* Header badge - straddles the top border */}
        <div className='absolute left-1/2 top-0 z-10 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap'>
          <div className='inline-flex items-center gap-2 rounded-pill border-hairline border-feedback-color-warning-lighter bg-feedback-color-warning-lightest px-4 py-1 text-sm font-semibold text-feedback-color-warning-darkest dark:bg-[#fff9e0] dark:text-[#dca859] [&_svg_path]:fill-current'>
            <StarIcon />
            <span className='font-semibold'>Como pontuar</span>
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <EditIcon  />
          <span className='text-md text-mono-color-darkest'>
            Assista videoaulas
          </span>
        </div>
        <div className='flex items-center gap-2'>
          <PencilIcon />
          <span className='text-md text-mono-color-darkest'>
            Faça exercícios
          </span>
        </div>
      </div>
    </div>
  );
};

export default HowToScoreCard;
